import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-info\">\r\n    <path d=\"M15 25C9.5 25 5 20.5 5 15S9.5 5 15 5s10 4.5 10 10-4.5 10-10 10zm0-1c5 0 9-4.1 9-9s-4-9-9-9-9 4-9 9 4 9 9 9zm.8-15.3c.3.3.4.6.4 1s-.2.7-.4 1c-.3.3-.6.4-1 .4-.8 0-1.4-.6-1.4-1.4 0-.4.2-.7.4-1 .2-.2.6-.4 1-.4s.7.1 1 .4zM17.4 21v-1c-1.2-.1-1.3-.2-1.3-1.6v-6.3c-1.1.3-2.2.6-3.3.7v1c1 .1 1.1.2 1.1 1.5v3.1c0 1.4-.1 1.5-1.3 1.6v1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol